import { useEffect } from 'react'
import { useAuth } from 'store'

const useGallery = (launch?: Boolean) => {
  const { session, checkUserAuth, scrubAuthAndLogin } = useAuth()

  // Check if the session has expired when the tab is refocused
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        // Check if the session has expired
        await session?.validate()
        if (session?.hasExpired) {
          scrubAuthAndLogin()
        }
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [session])

  // Start Gallery Here.
  useEffect(() => {
    // Check if user is authenticated.
    if (launch) {
      checkUserAuth()
    }
  }, [])
}

export default useGallery
